import { render } from "./App.vue?vue&type=template&id=27df6959"
const script = {}

import "./App.vue?vue&type=style&index=0&id=27df6959&lang=css"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__